<script>
    import Scroll from "../windows/Scroll.svelte";
    import photos from "../../stores/photos.js";
    import windows from "../../stores/windows.js";
    import t from "../../localization/t.js";

    const MAXIMUM_PHOTOS_IN_ROLL = 36;

    export let window;

    let innerWidth;

    $: reversed = $photos
        .slice(-MAXIMUM_PHOTOS_IN_ROLL)
        .reverse()
        .map((photo, index) => ({
            ...photo,
            title: titleForPhoto(photo, index)
        }));

    function didClickPhoto(photo, index) {
        const id = windows.open("photo", {
            photos: reversed,
            index
        });

        windows.focus(id);
    }

    function titleForPhoto(photo, index) {
        return `IMG_${photo.createdAt.toString().substr(-4)}.jpg`;
    }
</script>

<svelte:window bind:innerWidth />

{#if reversed.length > 0}
    <Scroll isFocused={window.isFocused}>
        <ul>
            {#each reversed as photo, index}
                <li>
                    <img src={photo.url} alt={photo.title} on:click={() => didClickPhoto(photo, index)} />
                    <p>{photo.title}</p>
                </li>
            {/each}
        </ul>

        <span>{t("photos.source")}</span>
    </Scroll>
{:else}
    <div class="empty">{t("photos.empty")}</div>
{/if}

<style>
    ul {
        gap: 5px;
        display: flex;
        flex-wrap: wrap;
        margin: 0;
        padding: 0;
    }

    li {
        display: inline-block;
        aspect-ratio: 1;
        list-style-type: none;
        width: calc((100% - 10px) / 3);
    }

    li > img {
        display: block;
        cursor: pointer;
        background: var(--chrome-hsl);
        aspect-ratio: 1;
        width: 100%;
        object-fit: cover;
    }

    p {
        margin-top: 5px;
        margin-bottom: 1em;
        text-align: center;
    }

    .empty {
        padding: var(--chrome-depth);
    }

    ul + span {
        display: block;
        margin-top: 1em;
        color: #666666;
    }
</style>
